module.exports = __webpack_public_path__ + "static/img/Metal Plank 250mm X 2,5m.857566a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Metal Plank 250mm X 2,5m.jpg
// module id = 89
// module chunks = 1